import AxiosClient from 'src/redux/AxiosClient'
import type {CookieConsent} from './types'

const COOKIE_CONSENT_URL = '/user/cookie-consent'

export const getCookieConsent = (toolkit: any) => {
  return AxiosClient('GET', COOKIE_CONSENT_URL, [], toolkit, [])
}

export const postCookieConsent = (payload: CookieConsent, toolkit: any) => {
  return AxiosClient('POST', COOKIE_CONSENT_URL, payload, toolkit, [])
}
